import {
  OrderCargoInfo,
  OrderCargoServiceType,
  OrderItem,
  OrderItemClient,
  OrderShortItem,
  TerminalScheduleItem
} from 'schema'
import { OrderShortPoint } from 'schema/models/order_short_point'

import { getTotalCargoParams } from './helpers/cargo'
import { TSelectCustomer } from './types'

export const emptyCustomer: TSelectCustomer = {
  id: '',
  type: OrderItemClient.type.LEGAL,
  name: '',
  inn: '',
  kpp: '',
  hasSpecialCargoLimits: false
}

const DEPARTURE_PARTNER = {
  type: 'legal',
  company: {
    name: 'КДВ Групп',
    inn: '7017094419',
    kpp: '701701001',
    legalAddress: '634057, Томская область, г.Томск, ул. Пр. Мира, д.20.'
  },
  contact: {
    name: 'Мельничук Светлана',
    phone: '79848153443',
    phoneExt: ''
  }
}

const DESTINATION_PARTNER = {
  type: 'legal',
  company: {
    name: 'БРИДЖТАУН ФУДС ЗАО',
    inn: '7715290822',
    kpp: '332801001',
    legalAddress: '600026, Владимирская обл, Владимир г, Куйбышева ул., дом № 3'
  },
  contact: {
    name: 'Федукина Ксения',
    phone: '73750436687',
    phoneExt: ''
  }
}

export const DEPARTURE_POINT = {
  terminal: {
    id: 'b5d59be9-9d40-11e3-a78f-001b24936c9e',
    name: 'QP5 Новокузнецк',
    address: 'Кемеровская область - Кузбасс, г Новокузнецк, р-н Кузнецкий, ул Малоэтажная, д 9 к 4',
    unpaidDays: 3,
    latitude: '53.781762',
    longitude: '87.230097',
    schedule: [
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.SAT,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.SUN,
        from: '07:00',
        to: '23:00'
      }
    ],
    phones: ['78002504099'],
    emails: ['support@qp5-express.ru'],
    isDeparture: true,
    isDestination: true
  },
  isCourier: false,
  addressDetail: {
    address: 'Владимирская обл., г Владимир, ул Куйбышева, д 3 ',
    latitude: '56.157714',
    longitude: '40.370954',
    comment: ''
  }
}

export const DESTINATION_POINT = {
  terminal: {
    id: 'b5d59be9-9d40-11e3-a78f-001b24936c9e',
    name: 'QP5 Новокузнецк',
    address: 'Кемеровская область - Кузбасс, г Новокузнецк, р-н Кузнецкий, ул Малоэтажная, д 9 к 4',
    unpaidDays: 3,
    latitude: '53.781762',
    longitude: '87.230097',
    schedule: [
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.MON,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.TUE,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.WED,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.THU,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.FRI,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.SAT,
        from: '07:00',
        to: '23:00'
      },
      {
        dayOfWeek: TerminalScheduleItem.dayOfWeek.SUN,
        from: '07:00',
        to: '23:00'
      }
    ],
    phones: ['78002504099'],
    emails: ['support@qp5-express.ru'],
    isDeparture: true,
    isDestination: true
  },
  addressDetail: {
    address: 'Владимирская обл., г Владимир, ул Куйбышева, д 3 ',
    latitude: '56.157714',
    longitude: '40.370954',
    comment: ''
  },
  isCourier: false
}

const CARGO = {
  about: 'Груз бананов',
  height: 120,
  length: 80,
  price: '20000',
  type: {
    id: OrderCargoServiceType.Id.PALLET
    // name: 'Палета'
  },
  weight: 80,
  width: 80,
  amount: 1
}

const CARGO_TOTAL = {
  type: {
    // name: 'Гибкий',
    id: OrderCargoServiceType.Id.CUSTOM
  },
  height: 15,
  width: 88,
  length: 51,
  weight: 421,
  volume: 0.412,
  about: '12',
  price: 412,
  amount: 5
}

const cargoTypeTotal = OrderCargoInfo.type.TOTAL

// @ts-ignore
const totalParams = getTotalCargoParams({ cargoType: cargoTypeTotal, cargoTotal: CARGO_TOTAL })

const CARGO_TOTAL_FORMATTED = {
  totalWeight: totalParams.weight,
  totalVolume: totalParams.volume
}

export const ORDER = {
  id: '36131614-6b62-49dd-a174-ba631bb1bf42',
  serialId: 49565,
  barcode: '2300000430783',
  status: OrderItem.Status.DEPARTURE_TERMINAL,
  paymentStatus: OrderItem.paymentStatus.NO,
  departure: {
    partner: DEPARTURE_PARTNER,
    point: DEPARTURE_POINT,
    departureDate: '2023-06-08'
  },
  destination: {
    partner: DESTINATION_PARTNER,
    point: DESTINATION_POINT,
    destinationDate: '2023-06-15'
  },
  cargoInfo: {
    type: OrderCargoInfo.type.SEPARATE,
    separate: CARGO,
    total: CARGO_TOTAL_FORMATTED
  },
  price: '362.0000',
  addressDetail: {
    address: 'Владимирская обл., г Владимир, ул Куйбышева, д 3 ',
    latitude: '56.157714',
    longitude: '40.370954',
    comment: ''
  }
}

export const ORDERS: OrderShortItem[] = [
  {
    id: 'f5f97de6-34ab-4a72-81a2-8b6d7b5ead26',
    status: OrderItem.Status.DEPARTURE_TERMINAL,
    totalPrice: '299.0000',
    isCargoAccepted: true,
    cargoInfo: {
      weight: 1328,
      volume: 3
    },
    barcode: '2300000430776',
    serialId: 49564,
    paymentStatus: OrderItem.paymentStatus.NO,
    departureDate: '2023-06-08',
    access: {
      copy: true,
      cancel: false
    },
    departure: {
      partnerName: '123',
      pointName: '123',
      pointType: OrderShortPoint.pointType.TERMINAL
    },
    destination: {
      partnerName: '123',
      pointName: '123',
      pointType: OrderShortPoint.pointType.TERMINAL
    }
  },
  {
    isCargoAccepted: true,
    departure: {
      partnerName: '123',
      pointName: '123',
      pointType: OrderShortPoint.pointType.TERMINAL
    },
    destination: {
      partnerName: '123',
      pointName: '123',
      pointType: OrderShortPoint.pointType.TERMINAL
    },
    id: '9443e48e-36b8-40f4-9310-c8c34c3fda42',
    status: OrderItem.Status.TRANSIT,
    totalPrice: '233.0000',
    cargoInfo: {
      volume: 3,
      weight: 15000
    },
    barcode: '2300000431018',
    serialId: 49557,
    paymentStatus: OrderItem.paymentStatus.NO,
    departureDate: '2023-06-08',
    access: {
      copy: true,
      cancel: false
    }
  }
]
